var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Container',{staticStyle:{"padding":"20px"}},[_c('div',{staticStyle:{"width":"960px","margin":"0 auto"}},[_c('BaseSegment',{attrs:{"title":"企业基础信息配置","collapse":false}}),_c('BaseSegment',{attrs:{"title":"业务类型","collapse":false}}),_c('BaseSegment',{attrs:{"title":"工程配置","collapse":false}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }